<template>
  <div class="product-specs">
    <div
      v-for="(group, index) in props.groups"
      :key="index"
      :class="{
        'product-specs__group': true,
        [`product-specs__group--table`]: true
      }"
    >
      <header
        v-if="group.features && group.features.length > 0"
        class="product-specs__group-header text-break"
      >
        <Component
          :is="props.headlineTag"
          :class="{
            'product-specs__group-headline': true,
            [`product-specs__group-headline--table`]: true
          }"
        >
          {{ group.title }}
        </Component>
      </header>
      <div
        v-if="group.features && group.features.length > 0"
        class="product-specs__group-content"
      >
        <TableBlock class="product-specs__spec-table">
          <table>
            <tbody>
              <tr
                v-for="(item, featureIndex) in group.features"
                :key="featureIndex"
              >
                <td
                  v-if="(item.label && item.label !== '') || item.value"
                  class="rte-text left-col"
                >
                  <span v-if="item.label && item.label !== ''">
                    <a
                      :href="
                        getProductFeatureLink(
                          item.label,
                          props.documentationUrlSlug
                        )
                      "
                      target="_blank"
                    >
                      {{ item.value }}
                    </a>
                  </span>
                  <span v-else>
                    {{ item.value }}
                  </span>
                </td>
                <td
                  v-if="(item.label && item.label !== '') || item.value"
                  class="rte-text right-col"
                >
                  <div
                    v-if="(item.label && item.label !== '') || item.value"
                    v-html="item.description"
                  ></div>
                </td>
              </tr>
            </tbody>
          </table>
        </TableBlock>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { TableBlock } from '@hypercodestudio/basler-components';
import { useProductDetailPageStore } from '~/stores/productDetailPageStore/productDetailPageStore';

const store = useProductDetailPageStore();

export interface FeatureTableValue {
  label: string;
  value: string;
  description: string | undefined;
}

export interface FeatureGroup {
  title: string;
  features?: FeatureTableValue[];
  items?: string;
}

export interface Props {
  groups: FeatureGroup[];
  headlineTag?: string;
  documentationUrlSlug: string;
}

const props = withDefaults(defineProps<Props>(), {
  headlineTag: 'h4'
});

const getProductFeatureLink = (ref: string, slug: string) => {
  const re = new RegExp(slug, 'gi');
  const product = store.decoratedProduct?.name ?? '';
  const param = product.match(re) ?? '';
  if (param[0] !== null && param[0] !== '') {
    return ref + '?filter=Camera:' + param[0];
  } else {
    return ref;
  }
};
</script>

<style scoped>
.left-col {
  width: 40%;
}
.right-col {
  width: 60%;
}
@media (max-width: 768px) {
  .left-col {
    width: 100%;
    font-weight: bold;
    border-bottom: none;
  }
  .right-col {
    width: 100%;
  }
  .product-specs__group {
    margin-block-end: var(--spacing-size-small);
  }
}
</style>
